import { useCallback, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Urls } from "../../../utils/constant";
import { useApi } from "../apiCall/useApi";
import useFullPageLoader from "../Common/PageLoader/useFullPageLoader";
import {
  hidePageLoader,
  showPageLoader,
} from "../../reducers/Common/PageLoader/PageLoader.reducer";
import {
  setDoctorComboList,
  setDoctorAvailabilityList,
  setAreaComboList,
  setWeekDayList,
} from "../../reducers/DoctorAvailability/DoctorAvailability.reducer";
import { getDoctorList, getAreaList, getWeekDayList } from "../../selectors/DoctorAvailability/doctorAvailability.selector";

const COLUMN_LIST = [
  {
    field: "sr_no",
    headerName: "sr. no.",
    flex: 1,
  },
  {
    field: "doctor_name",
    headerName: "Doctor Name",
    flex: 2,
  },
  {
    field: "area_name",
    headerName: "Area Name",
    flex: 2,
  },
  {
    field: "week_name",
    headerName: "Week day",
    flex: 2,
  },
  {
    field: "morning_from_time",
    headerName: "Morning From Time ",
    flex: 2,
  },
  {
    field: "morning_upto_time",
    headerName: "Morning Upto Time",
    flex: 2,
  },
  {
    field: "evening_from_time",
    headerName: "Evening From Time",
    flex: 2,
  },
  {
    field: "evening_upto_time",
    headerName: "Evening Upto Time",
    flex: 2,
  },
];

export default function useDoctorAvailability() {
  const dispatch = useDispatch();
  const { apiPost } = useApi();
  const [loading, setLoading] = useState(false);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [DoctorId, setDoctorId] = useState("");
  const [AreaId, setAreaId] = useState("");
  const [weekDay, setWeekDay] = useState("");
  const doctorList = useSelector(getDoctorList);
  const areaList = useSelector(getAreaList);
  const weekDayList = useSelector(getWeekDayList);

  const fetchDoctorAvailability = useCallback(
    async ({ current_page = 1, row_count }) => {
      if (loading) return;
      setLoading(true);
      try {
        dispatch(showPageLoader());
        const { data } = await apiPost({
          url: Urls.doctorAvailabilityGet(),
          data: {
            doctor_id: DoctorId,
            area_id: AreaId,
            week_day: weekDay,
            page_size: row_count,
            current_page: current_page,
          },
        });
        // setting list to reducer
        dispatch(setDoctorAvailabilityList(data));
        setLoading(false);
        dispatch(hidePageLoader());
      } catch (err) {
        dispatch(hidePageLoader());
        console.log(err);
        setLoading(false);
      }
    },
    [loading, dispatch, apiPost, DoctorId, AreaId, weekDay]
  );

  const fetchDoctorComboList = useCallback(async () => {
    try {
      const { data } = await apiPost({
        url: Urls.getDoctorCombo(),
        data: {},
      });
      // setting list to reducer

      dispatch(setDoctorComboList(data.data));
    } catch (err) {
      console.log(err);
    }
  }, [apiPost, dispatch]);

  const findDoctorFromLabel = useCallback(
    (value) => {
      const selectedDoctorId = value
        ? doctorList.find((item) => item.label === value)?.id
        : null;
      setDoctorId(selectedDoctorId);
      return selectedDoctorId;
    },
    [doctorList]
  );

  const fetchAreaComboList = useCallback(async () => {
    try {
      const { data } = await apiPost({
        url: Urls.getAreaCombo(),
        data: {},
      });
      dispatch(setAreaComboList(data));
    } catch (err) {
      console.log(err);
    }
  }, [apiPost, dispatch]);

  const findAreaFromLabel = useCallback(
    (value) => {
      const selectedAreaId = value
        ? areaList.find((item) => item.label === value)?.id
        : null;
      setAreaId(selectedAreaId);
      return selectedAreaId;
    },
    [areaList]
  );

  const fetchWeekDayList = useCallback(async () => {
    try {
      const { data } = await apiPost({
        url: Urls.getWeekDayCombo(),
        data: {},
      });
      dispatch(setWeekDayList(data));
    } catch (err) {
      console.log(err);
    }
  }, [apiPost, dispatch]);

  const findWeekDayFromLabel = useCallback(
    (value) => {
      const selectedWeekDayId = value
        ? weekDayList.find((item) => item.label === value)?.id
        : null;

      setWeekDay(selectedWeekDayId);
      return selectedWeekDayId;
    },
    [weekDayList]
  );

  return {
    gridHeaders: COLUMN_LIST,
    loading,
    loader,
    DoctorId,
    AreaId,
    weekDay,
    findDoctorFromLabel,
    findAreaFromLabel,
    findWeekDayFromLabel,
    fetchDoctorAvailability,
    fetchDoctorComboList,
    fetchAreaComboList,
    fetchWeekDayList,
  };
}
